import { PageHero } from "../components/site/PageHero";
import { BenefitsSection } from "../components/home/BenefitsSection";
import { HowItWorks } from "../components/home/HowItWorks";
import { CtaBanner } from "../components/site/CtaBanner";
import { Reveal } from "../components/site/Reveal";
import { SectionHeading } from "../components/site/SectionHeading";
import { PrimaryButton, OutlineButton } from "../components/site/Buttons";
import { KeyRound, UserCheck } from "lucide-react";
import { MemberLoginAction } from "../components/site/MemberLogin";
import { Seo } from "../components/site/Seo";

export default function Membership() {
  return (
    <main data-testid="membership-page">
      <Seo
        title="Membership | MST — Multiple Stream Team"
        description="MST is a private, invite-only organization. Learn how membership works, what members receive, and how to apply."
        path="/membership"
      />
      <PageHero
        label="Membership"
        title={<>Membership Is Earned, <span className="text-[#009BFF]">Not Bought.</span></>}
        text="MST is a private, invite-only organization. Every member enters through a private approval process designed to protect the quality, trust, and standards of the network."
      />
      <section className="bg-[#041525] py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading light label="Access" title="Two Ways Into the Network" />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
            <Reveal data-testid="membership-apply-card" className="rounded-2xl border border-[#006FD6]/25 bg-gradient-to-b from-[#062541] to-[#041525] p-10">
              <div className="w-12 h-12 rounded-xl bg-[#009BFF]/10 border border-[#009BFF]/30 flex items-center justify-center">
                <UserCheck size={22} strokeWidth={1.5} className="text-[#00C4F4]" />
              </div>
              <h3 className="mt-6 text-xl font-extrabold text-white" style={{ fontFamily: "var(--font-heading)" }}>New Applicants</h3>
              <p className="mt-3 text-sm text-[#B7C0CC] leading-relaxed">
                Submit a membership application. MST reviews every applicant for fit, alignment,
                and eligibility. Approved applicants receive an invitation and available membership options.
              </p>
              <div className="mt-8"><PrimaryButton to="/apply" data-testid="membership-apply-btn">Apply for Membership</PrimaryButton></div>
            </Reveal>
            <Reveal delay={0.12} data-testid="membership-login-card" className="rounded-2xl border border-white/10 bg-[#020A12]/60 p-10">
              <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/15 flex items-center justify-center">
                <KeyRound size={22} strokeWidth={1.5} className="text-white/80" />
              </div>
              <h3 className="mt-6 text-xl font-extrabold text-white" style={{ fontFamily: "var(--font-heading)" }}>Existing Members</h3>
              <p className="mt-3 text-sm text-[#B7C0CC] leading-relaxed">
                Approved members access the private MST platform for networking, governance,
                events, masterclasses, business opportunities, and internal MST operations.
              </p>
              <div className="mt-8">
                <MemberLoginAction
                  render={(p) => (
                    <OutlineButton {...p} data-testid="membership-login-btn">Member Login</OutlineButton>
                  )}
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <BenefitsSection />
      <HowItWorks />
      <CtaBanner />
    </main>
  );
}
